import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import CurdService from './../../admin/adminServices/curd.services'
import { setMessage } from '../../store/slices/message'

export const getTestimonials = createAsyncThunk(
    'imgTestimonials', async (id = 4, thunkAPI) => {
        const { rejectWithValue } = thunkAPI
        try {
            const res = await CurdService.get("imgcatdata", id);
            return res.data
        } catch (error) {
            const message = error.message
            thunkAPI.dispatch(setMessage(message))
            return rejectWithValue(error.message)
        }
    })


const imgTestimonials = createSlice({
    name: 'imgTestimonials',
    initialState: { isloading: false, img: [] },
    extraReducers: (builder) => {
        builder
            // Get Testimonials Images
            .addCase(getTestimonials.pending, (state) => {
                state.isloading = true
            })
            .addCase(getTestimonials.fulfilled, (state, action) => {
                state.isloading = false;
                if (Object.keys(action.payload).length !== 0) {
                    state.img = action.payload;
                }
            })
            .addCase(getTestimonials.rejected, (state) => {
                state.isloading = false
            })
    },
})

export default imgTestimonials.reducer